export default __webpack_public_path__ + "static/media/logoCommerce.361739ca.png";